<template>
  <div class="loading-more-button">
    <Loading v-if="loading" type="line" :center="false" class="loading-more-button-loading" />

    <div class="loading-more-button-wrap" v-if="remaining > 0">
      <button class="loading-more-button-btn" :class="{ 'loading-more-button-btn-loading': loading }"
        :disabled="loading" @click="$emit('click')">
        <span class="loading-more-button-icon">
          <i class="fa-solid fa-arrows-rotate" :class="{ 'fa-spin': loading }"></i>
        </span>
        <span class="loading-more-button-text">{{ title }}</span>
        <span class="loading-more-button-badge">
          + {{ remaining }} {{ remaining === 1 ? itemLabel : itemLabelPlural }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import Loading from "./Loading.vue";

export default {
  name: "LoadingMoreButton",
  components: { Loading },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    remaining: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "Carregar mais",
    },
    itemLabel: {
      type: String,
      default: "item",
    },
    itemLabelPlural: {
      type: String,
      default: "itens",
    },
  },
};
</script>

<style scoped>
.loading-more-button-loading {
  margin-top: 16px;
}

.loading-more-button-wrap {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.loading-more-button-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 11px 28px;
  background: var(--bg-base);
  border: 1.5px dashed var(--border-color);
  border-radius: 999px;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-secondary);
  transition: background 0.18s, border-color 0.18s, color 0.18s, box-shadow 0.18s;
  outline: none;
}

.loading-more-button-btn:hover {
  background: var(--bg-hover);
  border-color: var(--color-brand);
  color: var(--color-brand);
  box-shadow: var(--shadow-sm);
}

.loading-more-button-btn:active {
  transform: scale(0.97);
}

.loading-more-button-btn-loading {
  pointer-events: none;
  opacity: 0.7;
}

.loading-more-button-icon {
  font-size: 14px;
  color: var(--color-brand);
}

.loading-more-button-text {
  letter-spacing: 0.3px;
}

.loading-more-button-badge {
  background: var(--bg-elevated);
  color: var(--color-brand);
  font-size: 11.5px;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: 999px;
  letter-spacing: 0.2px;
}
</style>
